//
//
//
//
//
//
//
//
//
//
//
//

export default {
    layout: 'blank',
    head() {
        return {
            title: '首页'
        }
    },
    props: {
        error: {
            type: Object
        }
    }
}
